import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import useAuth from 'src/hooks/useAuth';
import MainLayout from 'src/layouts/MainLayout';

const AuthGuard = () => {
  const { isAuthenticated } = useAuth();
  let location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
};

export default AuthGuard;
